// Localized public URLs. Each page key maps to one clean, lowercase slug per language.
// The localized slug is the official canonical URL; legacy English slugs redirect to it.
export const PUBLIC_SLUGS = {
  home: { fr: "", en: "", es: "" },
  about: { fr: "/a-propos", en: "/about", es: "/quienes-somos" },
  opportunities: { fr: "/opportunites", en: "/opportunities", es: "/oportunidades" },
  realEstate: { fr: "/immobilier", en: "/real-estate", es: "/inmobiliario" },
  careers: { fr: "/carrieres", en: "/careers", es: "/carreras" },
  humanDev: { fr: "/developpement-humain", en: "/human-development", es: "/desarrollo-humano" },
  projects: { fr: "/projets", en: "/projects", es: "/proyectos" },
  contact: { fr: "/nous-joindre", en: "/contact", es: "/contacto" },
  apply: { fr: "/candidature", en: "/apply", es: "/candidatura" },
  join: { fr: "/rejoindre", en: "/join", es: "/unirse" },
  privacy: { fr: "/confidentialite", en: "/privacy", es: "/privacidad" },
  terms: { fr: "/conditions", en: "/terms", es: "/terminos" },
};

// Indexable marketing pages, in navigation and sitemap order.
export const INDEXABLE_KEYS = [
  "home", "about", "opportunities", "realEstate", "careers", "humanDev", "projects",
  "contact", "apply", "privacy", "terms",
];

export function routeSlug(key, lang) {
  const entry = PUBLIC_SLUGS[key];
  if (!entry) return "";
  return entry[lang] ?? entry.en;
}

export function routePath(key, lang) {
  return `/${lang}${routeSlug(key, lang)}`;
}

export function pathsByLang(key) {
  return { fr: routeSlug(key, "fr"), en: routeSlug(key, "en"), es: routeSlug(key, "es") };
}

/** Reverse lookup of any localized or legacy slug -> page key. */
export function keyFromSlug(slug) {
  const clean = slug.replace(/\/$/, "");
  for (const [key, byLang] of Object.entries(PUBLIC_SLUGS)) {
    if (Object.values(byLang).includes(clean)) return key;
  }
  return null;
}

/** Legacy English slugs that must 301/redirect to the localized slug of the current language. */
export function legacyRedirects(lang) {
  return INDEXABLE_KEYS.filter((key) => key !== "home")
    .map((key) => ({ key, from: PUBLIC_SLUGS[key].en, to: routeSlug(key, lang) }))
    .filter(({ from, to }) => from && from !== to);
}
